import { render, staticRenderFns } from "./upload-record.vue?vue&type=template&id=eef47f44&scoped=true&"
import script from "./upload-record.vue?vue&type=script&lang=js&"
export * from "./upload-record.vue?vue&type=script&lang=js&"
import style0 from "./upload-record.vue?vue&type=style&index=0&id=eef47f44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef47f44",
  null
  
)

export default component.exports